import { useEffect, useRef } from 'react';

/** Re-read existing capacity while the owner is waiting; never open a form or buy. */
export function useOwnerSeatRefresh(waiting: boolean, refreshLicenses: () => Promise<void>) {
  const inFlight = useRef(false);
  useEffect(() => {
    if (!waiting) return;
    const timer = setInterval(() => {
      if (inFlight.current) return;
      inFlight.current = true;
      // The licence source owns error presentation. Avoid overlapping polls
      // when a slow request lasts longer than the refresh interval.
      void refreshLicenses().finally(() => { inFlight.current = false; });
    }, 15000);
    return () => clearInterval(timer);
  }, [waiting, refreshLicenses]);
}
